import { render, staticRenderFns } from "./CyberboardNovel3.vue?vue&type=template&id=a644b768&scoped=true"
import script from "./CyberboardNovel3.vue?vue&type=script&lang=ts"
export * from "./CyberboardNovel3.vue?vue&type=script&lang=ts"
import style0 from "./CyberboardNovel3.vue?vue&type=style&index=0&id=a644b768&prod&lang=scss&scoped=true"
import style1 from "./CyberboardNovel3.vue?vue&type=style&index=1&id=a644b768&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a644b768",
  null
  
)

export default component.exports